import { Component, OnInit, Input } from '@angular/core';
import { PlayerListViewModel } from '../../../shared/models/player.model';
import { TextDividerComponent } from '../text-divider/text-divider.component';
import { TeamRosterPlayerComponent } from '../team-roster-player/team-roster-player.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-team-roster',
    imports: [CommonModule, TextDividerComponent, TeamRosterPlayerComponent, TranslateModule],
    templateUrl: './team-roster.component.html',
    styleUrls: ['./team-roster.component.css']
})
export class TeamRosterComponent implements OnInit {
  @Input() Roster: PlayerListViewModel[];
  @Input() TeamIcon: string;
  @Input() GameId: string;

  goalies: PlayerListViewModel[] = [];
  defenders: PlayerListViewModel[] = [];
  forwards: PlayerListViewModel[] = [];

  constructor() { }

  ngOnInit() {
    this.goalies = this.Roster.filter(el => el.PlayerView.PositionId === 1);
    this.defenders = this.Roster.filter(el => el.PlayerView.PositionId === 2 || el.PlayerView.PositionId === 3);
    this.forwards = this.Roster.filter(el => el.PlayerView.PositionId > 3);
  }

}
